import {effect, inject, Injectable, NgZone, signal} from '@angular/core';
import { Observable, Subject } from 'rxjs';
import * as UtilityMediaAccess from '@serv/media_access/utility';
import {NavigatorDeviceDetectorService} from '@llm/service/navigator_device_detector.service';
//import {Tools_aiConsoleService} from "@llm/service/tools_ai-console.service";

@Injectable({ providedIn: 'root' })
export class SpeechRecognitionService {
  private recognition: UtilityMediaAccess.SpeechRecognition;
  private transcript$ = new Subject<string>();
  public readonly transcriptionSession$ = signal<string>('')
  //private _console = inject(Tools_aiConsoleService);

  // flags e timers
  public readonly isRecognizing$ = signal<boolean>(false);
  private isIntentionalStop = false;
  private lastResultTime = 0;
  private restartTimer: ReturnType<typeof setTimeout> | null = null;

  // constantes de configuração
  private readonly RESTART_DELAY = 800;        // ms após onend
  private readonly SILENCE_THRESHOLD = 5_000;  // ms sem fala para considerar silêncio longo

  constructor(private ngZone: NgZone, private _detectorDevice: NavigatorDeviceDetectorService) {
    const SpeechRecognition: any = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
    this.recognition = new SpeechRecognition();

    // configurações
    this.recognition.lang = 'pt-BR';
    this.recognition.interimResults = true;
    this.recognition.maxAlternatives = 1;

    if (this._detectorDevice.isDesktop()) {
      this.recognition.continuous = true;
    } else {
      this.recognition.continuous = false;
    }
   //this._console.log('✅ Configurando SpeechRecognition ');

    // evento de resultado
    this.recognition.onresult = (event) => {
      const text:string = event.results[event.resultIndex][0].transcript.trim().toLowerCase();
      const transcript = Array.from(event.results)
        .map((result: any) => result[0].transcript)
        .join(' ')
        .toLowerCase();
      this.lastResultTime = Date.now();
      this.ngZone.run(() => this.transcriptionSession$.set(transcript));
      //this.transcriptionSession$.update(value => value +' '+ text)
     //this._console.log('🎤 Transcripción recibida:', transcript);
     //this._console.log('🎤 Transcripción total actual:', this.transcriptionSession$());
    };

    // erro: tratar no-speech e audio-capture
    this.recognition.onerror = (event: any) => {
      if (event.error === 'no-speech' || event.error === 'audio-capture') {
        // marque como intencional para evitar restart
       //this._console.log(`⚠️ Error de reconocimiento: ${event.error}`);
        this.isIntentionalStop = true;
        this.isRecognizing$.set(false);
      } else {
       //this._console.warn('SpeechRecognition error:', event.error);
      }
    };

    // fim de captura: decidir se restartar
    // só reinicia se não foi parada intencionalmente,
    // houve resultado recente (silêncio curto) e não estiver no modo stop
    this.recognition.onend = () => {
      this.isRecognizing$.set(false);
      const sinceLast = Date.now() - this.lastResultTime;
     //this._console.log('Tiempo de silencio:', sinceLast)
      if (
        !this.isIntentionalStop &&
        this.lastResultTime > 0
        //&& sinceLast < this.SILENCE_THRESHOLD
      ) {
        if (this._detectorDevice.isDesktop()) {
          this.scheduleRestart();
        }
      }
    };


    effect(() => {
   //this._console.log('This session:', this.transcriptionSession$())
    });
  }

  /** Inicia o reconhecimento (chame só uma vez) */
  start(): void {
    if (this.isRecognizing$()) { return; }
    this.isIntentionalStop = false;
    this.isRecognizing$.set(true);
    this.lastResultTime = Date.now();
    try {
      this.recognition.start();
    } catch { /* já rodando */ }
  }

  /** Para o reconhecimento completamente */
  stop(): void {
    this.isIntentionalStop = true;
    this.isRecognizing$.set(false);
    clearTimeout(this.restartTimer);
    this.recognition.stop();
    this.transcriptionSession$.set('');
  }

  /** agenda um restart com debounce */
  private scheduleRestart() {
    clearTimeout(this.restartTimer);
    this.restartTimer = setTimeout(() => {
      if (!this.isIntentionalStop) {
        this.isRecognizing$.set(true);
        this.recognition.start();
      }
    }, this.RESTART_DELAY);
  }
}
